module.exports = __webpack_public_path__ + "img/logo_fastead_escolas.c586cb24.png";